import {
    SV_PEOPLE_CHANGE_CONTRIBUTOR,
    SV_PEOPLE_CHANGE_OWNER,
    SV_PEOPLE_CHANGE_PARTICIPANT,
    SV_PEOPLE_CHANGE_VIEWERS,
    SV_PEOPLE_VIEW,
    SV_RECORDING_ANNOTATIONS_CREATE,
    SV_SUMMARY_EDIT,
} from 'constants/LU_Permissions';
import * as Immutable from 'immutable';
import {evaluationsNavItemIsVisible, navItemIsVisibleWithPermissions} from '../utils/session-viewer-utils';

import type {NavigationItem} from 'components/sidebar-navigation-bar/sidebar-navigation-bar';

export const SCENARIOS_REQUEST = 'SESSION_VIEWER_SCENARIOS_REQUEST';
export const SCENARIOS_SUCCESS = 'SESSION_VIEWER_SCENARIOS_SUCCESS';

export const COURSES_REQUEST = 'SESSION_VIEWER_COURSES_REQUEST';
export const COURSES_SUCCESS = 'SESSION_VIEWER_COURSES_SUCCESS';

export const COURSES_SCENARIOS_REQUEST = 'SESSION_VIEWER_COURSES_SCENARIOS_REQUEST';
export const COURSES_SCENARIOS_SUCCESS = 'SESSION_VIEWER_COURSES_SCENARIOS_SUCCESS';

export const ORGANIZATIONS_REQUEST = 'SESSION_VIEWER_ORGANIZATIONS_REQUEST';
export const ORGANIZATIONS_SUCCESS = 'SESSION_VIEWER_ORGANIZATIONS_SUCCESS';

export const LOCATIONS_REQUEST = 'SESSION_VIEWER_LOCATIONS_REQUEST';
export const LOCATIONS_SUCCESS = 'SESSION_VIEWER_LOCATIONS_SUCCESS';

export const SIMULATORS_REQUEST = 'SESSION_VIEWER_SIMULATORS_REQUEST';
export const SIMULATORS_SUCCESS = 'SESSION_VIEWER_SIMULATORS_SUCCESS';

export const SESSION_REQUEST = 'SESSION_REQUEST';
export const SESSION_SUCCESS = 'SESSION_SUCCESS';
export const SESSION_FAILURE = 'SESSION_FAILURE';

export const DELETE_SESSION_REQUEST = 'SESSIONS_DELETE_SESSION_REQUEST';
export const DELETE_SESSION_SUCCESS = 'SESSIONS_DELETE_SESSION_SUCCESS';
export const DELETE_SIMULATOR_DATA_SUCCESS = 'DELETE_SIMULATOR_DATA_SUCCESS';

export const SESSION_VIEW_ACTIVITY_REQUEST = 'SESSION_VIEW_ACTIVITY_REQUEST';
export const SESSION_VIEW_ACTIVITY_SUCCESS = 'SESSION_VIEW_ACTIVITY_SUCCESS';

export const SESSION_VIEW_COUNT_REQUEST = 'SESSION_VIEW_COUNT_REQUEST';
export const SESSION_VIEW_COUNT_SUCCESS = 'SESSION_VIEW_COUNT_SUCCESS';

export const SESSION_EVALUATIONS_COUNT_REQUEST = 'SESSION_EVALUATIONS_COUNT_REQUEST';
export const SESSION_EVALUATIONS_COUNT_SUCCESS = 'SESSION_EVALUATIONS_COUNT_SUCCESS';

export const SESSION_PEOPLE_REQUEST = 'SESSION_PEOPLE_REQUEST';
export const SESSION_PEOPLE_SUCCESS = 'SESSION_PEOPLE_SUCCESS';

export const SESSION_CREATE_LINK_REQUEST = 'SESSION_CREATE_LINK_REQUEST';
export const SESSION_CREATE_LINK_SUCCESS = 'SESSION_CREATE_LINK_SUCCESS';

export const SESSION_DEACTIVATE_LINK_REQUEST = 'SESSION_DEACTIVATE_LINK_REQUEST';
export const SESSION_DEACTIVATE_LINK_SUCCESS = 'SESSION_DEACTIVATE_LINK_SUCCESS';

export const DISPOSE_SESSION_DETAIL_STORE = 'DISPOSE_SESSION_DETAIL_STORE';

export const SET_ON_SIDEBAR_TOGGLED = 'SET_ON_SIDEBAR_TOGGLED';

// get actions to render on trackbar
export const SESSION_ANNOTATIONS_REQUEST = 'SESSION_ANNOTATIONS_REQUEST';
export const SESSION_ANNOTATIONS_SUCCESS = 'SESSION_ANNOTATIONS_SUCCESS';

export const SESSION_PEOPLE_DEFAULTS_REQUEST = 'SESSION_PEOPLE_DEFAULTS_REQUEST';
export const SESSION_PEOPLE_DEFAULTS_SUCCESS = 'SESSION_PEOPLE_DEFAULTS_SUCCESS';

// viewer event log actions
export const SESSION_SIMULATOR_EVENTS_REQUEST = 'SESSION_SIMULATOR_EVENTS_REQUEST';
export const SESSION_SIMULATOR_EVENTS_SUCCESS = 'SESSION_SIMULATOR_EVENTS_SUCCESS';

export const SESSION_GUDRID_EVENTS_REQUEST = 'SESSION_GUDRID_EVENTS_REQUEST';
export const SESSION_GUDRID_EVENTS_SUCCESS = 'SESSION_GUDRID_EVENTS_SUCCESS';

export const SESSION_APPLICATION_FILES_REQUEST = 'SESSION_APPLICATION_FILES_REQUEST';
export const SESSION_APPLICATION_FILES_SUCCESS = 'SESSION_APPLICATION_FILES_SUCCESS';

// actions for sim graph data
export const SESSION_SIMULATOR_STATS_REQUEST = 'SESSION_SIMULATOR_STATS_REQUEST';
export const SESSION_SIMULATOR_STATS_SUCCESS = 'SESSION_SIMULATOR_STATS_SUCCESS';

// recent activity
export const SESSION_HISTORY_REQUEST = 'SESSION_HISTORY_REQUEST';
export const SESSION_HISTORY_SUCCESS = 'SESSION_HISTORY_SUCCESS';

// actions for people
export const SEARCH_OWNER_SUCCESS = 'SEARCH_OWNER_SUCCESS';

export const SEARCH_CONTRIBUTORS_SUCCESS = 'SEARCH_CONTRIBUTORS_SUCCESS';

export const SEARCH_PARTICIPANTS_SUCCESS = 'SEARCH_PARTICIPANTS_SUCCESS';

export const SEARCH_PATIENT_SUCCESS = 'SEARCH_PATIENT_SUCCESS';

export const SEARCH_VIEWERS_SUCCESS = 'SEARCH_VIEWERS_SUCCESS';

export const CREATE_RECORDING_ANNOTATION_REQUEST = 'CREATE_RECORDING_ANNOTATION_REQUEST';
export const CREATE_RECORDING_ANNOTATION_SUCCESS = 'CREATE_RECORDING_ANNOTATION_SUCCESS';

export const UPDATE_RECORDING_ANNOTATION_REQUEST = 'UPDATE_RECORDING_ANNOTATION_REQUEST';
export const UPDATE_RECORDING_ANNOTATION_SUCCESS = 'UPDATE_RECORDING_ANNOTATION_SUCCESS';

export const DELETE_RECORDING_ANNOTATION_REQUEST = 'DELETE_RECORDING_ANNOTATION_REQUEST';
export const DELETE_RECORDING_ANNOTATION_SUCCESS = 'DELETE_RECORDING_ANNOTATION_SUCCESS';

export const EXPORT_EVENT_LOG_REQUEST = 'SESSION_EXPORT_EVENT_LOG_REQUEST';
export const EXPORT_EVENT_LOG_SUCCESS = 'SESSION_EXPORT_EVENT_LOG_SUCCESS';

export const GET_SPRITES_ACCESS_REQUEST = 'SESSION_GET_SPRITES_ACCESS_REQUEST';
export const GET_SPRITES_ACCESS_SUCCESS = 'SESSION_GET_SPRITES_ACCESS_SUCCESS';

export const TOGGLE_SIM_GRAPH = 'TOGGLE_SIM_GRAPH';
export const TOGGLE_SLIDING_PANEL = 'TOGGLE_SLIDING_PANEL';
export const TOGGLE_EVENT_LOG_FILTERS = 'TOGGLE_EVENT_LOG_FILTERS';
export const TOGGLE_EVENT_LOG_SIMULATIONS = 'TOGGLE_EVENT_LOG_SIMULATIONS';
export const TOGGLE_EVENT_LOG_ANNOTATIONS = 'TOGGLE_EVENT_LOG_ANNOTATIONS';
export const TOGGLE_EVENT_LOG_GUDRID = 'TOGGLE_EVENT_LOG_GUDRID';
export const GUDRID_SESSION_DATA_RECEIVED = 'GUDRID_SESSION_DATA_RECEIVED'; // for receiving live gudrid data form socket
export const GUDRID_SESSION_DATA_CLEAR = 'GUDRID_SESSION_DATA_CLEAR';
export const SET_GUDRID_EVENTS_LOADED = 'SET_GUDRID_EVENTS_LOADED';
export const SET_RECORDING_ANNOTATIONS_LOADED = 'SET_RECORDING_ANNOTATIONS_LOADED';

export const SESSION_SWITCH = 'SESSION_SWITCH';

// How long (in milliseconds) must the user be viewing a session before it counts as a view?
export const SESSION_VIEW_TIMER = 10000;

export const SET_SESSION = 'SET_SESSION';

export const CLEAR_SESSION_TRANSCRIPTS = 'CLEAR_SESSION_TRANSCRIPTS';
export const SET_SESSION_TRANSCRIPTS = 'SET_SESSION_TRANSCRIPTS';

export const SET_TRIMMING_STATE = 'SET_TRIMMING_STATE';

export const ADD_UPDATED_EVALUATIONS = 'ADD_UPDATED_EVALUATIONS';
export const CLEAR_EVALUATION_UPDATE = 'CLEAR_EVALUATION_UPDATE';

/*
 * Explanation: the last panel is the last sidebar activity done in session viewer. If the viewer does not have the
 * panel open before leaving a session detail to go elsewhere on the site, the user will not see a sidebar upon
 * returning to that session or any other session.
 *
 * If, however, the user has "people" as the last open panel before
 * leaving, then the next session detail seen is people. If the user is in people edit mode when leaving, then the next
 * seen session will only be people.
 *
 * If the user has permissions to see a people panel in one session, but does not in another session, then user will see
 * a "RESTRICTED" panel.
 */
export const REORDER_STREAMS = 'REORDER_STREAMS';
export const UPDATE_SELECTED_RECORDING = 'UPDATE_SELECTED_RECORDING';

const NAV_ITEMS = {
    summary: {
        path: 'summary',
        component: 'ViewerSummary',
        name: 'summary',
        icon: 'subject',
        children: [
            {
                path: 'edit',
                component: 'ViewerEdit',
                icon: 'icon-edit',
                isVisible: navItemIsVisibleWithPermissions([SV_SUMMARY_EDIT]),
            },
            {
                path: 'activity',
                component: 'viewer-activity',
                name: 'activity',
                icon: 'ic_history',
                isVisible: navItemIsVisibleWithPermissions([SV_SUMMARY_EDIT]),
            },
        ],
    },
    people: {
        path: 'people',
        component: 'ViewerPeople',
        name: 'people',
        icon: 'group',
        isVisible: navItemIsVisibleWithPermissions([SV_PEOPLE_VIEW]),
        children: [
            {
                path: 'edit',
                component: 'ViewerPeopleEdit',
                icon: 'group',
                isVisible: navItemIsVisibleWithPermissions([
                    SV_PEOPLE_CHANGE_CONTRIBUTOR,
                    SV_PEOPLE_CHANGE_PARTICIPANT,
                    SV_PEOPLE_CHANGE_VIEWERS,
                    SV_PEOPLE_CHANGE_OWNER,
                ]),
            },
        ],
    },
    annotations: {
        path: 'annotations',
        component: 'ViewerAnnotations',
        name: 'annotations',
        icon: 'chat',
        isVisible: navItemIsVisibleWithPermissions([SV_RECORDING_ANNOTATIONS_CREATE]),
    },
    eventLog: {
        path: 'event-log',
        component: 'ViewerEventLog',
        name: 'eventLog',
        icon: 'event',
    },
    evaluations: {
        path: 'evaluations',
        component: 'viewer-evaluations',
        name: 'evaluations',
        icon: 'offline_pin',
        isVisible: evaluationsNavItemIsVisible,
        children: [
            {
                path: ':evaluationTemplateId',
                component: 'viewer-evaluations-take',
                name: 'take',
                icon: 'icon-edit',
            },
            {
                path: ':evaluationId/completed',
                component: 'viewer-evaluations-completed',
                name: 'completed',
                icon: 'icon-edit',
            },
            {
                path: ':evaluationId/edit',
                component: 'viewer-evaluations-edit',
                name: 'edit',
                icon: 'icon-edit',
            },
        ],
    },
    start: {
        path: 'start',
        component: 'ViewerNew',
        icon: 'subject',
    },
    transcript: {
        component: 'ViewerTranscript',
        icon: 'forum',
        name: 'transcript',
        path: 'transcript',
    },
    gudrid: {
        component: 'ViewerGudrid',
        icon: 'man',
        name: 'gudrid',
        path: 'gudrid',
    },
} satisfies {[key: string]: NavigationItem};

const PARTICIPANT_NAV_ITEMS = {
    evaluations: {
        path: 'evaluations',
        component: 'participant-viewer-evaluations',
        name: 'evaluations',
        icon: 'offline_pin',
        isVisible: evaluationsNavItemIsVisible,
        children: [
            {
                path: ':evaluationTemplateId',
                component: 'viewer-evaluations-take',
                name: 'take',
                icon: 'icon-edit',
            },
            {
                path: ':evaluationId/completed',
                component: 'viewer-evaluations-completed',
                name: 'completed',
                icon: 'icon-edit',
            },
        ],
    },
} satisfies {[key: string]: NavigationItem};

export const SIDEBAR_METADATA = Object.freeze<NavigationItem[]>([
    NAV_ITEMS.summary,
    NAV_ITEMS.people,
    NAV_ITEMS.annotations,
    NAV_ITEMS.eventLog,
    NAV_ITEMS.evaluations,
    NAV_ITEMS.transcript,
]);

export const SIDEBAR_METADATA_LIVE = Object.freeze<NavigationItem[]>([
    NAV_ITEMS.summary,
    NAV_ITEMS.people,
    NAV_ITEMS.annotations,
    NAV_ITEMS.eventLog,
    NAV_ITEMS.evaluations,
]);

export const SIDEBAR_METADATA_LIVE_GUDRID = Object.freeze<NavigationItem[]>([
    NAV_ITEMS.summary,
    NAV_ITEMS.people,
    NAV_ITEMS.annotations,
    NAV_ITEMS.eventLog,
    NAV_ITEMS.evaluations,
    NAV_ITEMS.gudrid,
]);

export const PARTICIPANT_SIDEBAR_METADATA = Object.freeze<NavigationItem[]>([
    NAV_ITEMS.summary,
    NAV_ITEMS.annotations,
    NAV_ITEMS.eventLog,
    PARTICIPANT_NAV_ITEMS.evaluations,
    NAV_ITEMS.transcript,
]);

export const SIM_GRAPH_DEFAULT_STATS = Immutable.List(['sbp', 'dbp', 'co', 'hr']);
export const SIM_GRAPH_VISIBLE_TRENDS = 'simGraphVisibleTrends';
